export default __webpack_public_path__ + "static/media/profile.d1308551.svg";